export function convertNormalizedPointsToPixelPoints(
  normalizedPoints: number[][],
  imageWidth: number,
  imageHeight: number,
): number[][] {
  return normalizedPoints.map(([x, y]) => [x * imageWidth, y * imageHeight]);
}

export function pixelsToNormalized(
  points: number[][],
  imageWidth: number,
  imageHeight: number,
): number[][] {
  return points.map(([x, y]) => [x / imageWidth, y / imageHeight]);
}

export function measureDistance(
  point: number[],
  nearbyPoint: number[],
  tolerance = 30,
): { isWithinTolerance: boolean; distance: number } {
  const [x1, y1] = point;
  const [x2, y2] = nearbyPoint;
  const distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
  return {
    isWithinTolerance: distance < tolerance,
    distance,
  };
}
